const VALID = undefined;

export const passwordSpecialCharacters = message => value => {
  const hasSpecialCharacters = value && value.match(/[^A-Za-z0-9]/);
  return hasSpecialCharacters ? VALID : message;
};

export const passwordContainsNumber = message => value => {
  const hasNumber = value && value.match(/[0-9]/);
  return hasNumber ? VALID : message;
};
